import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as API from "../libs/service";

export default function CountryLanguagePopup({ country = 'US', language = 'en', onDone, }) {

    const { mbData } = useSelector((s) => s.usersReducer);
    //console.log(mbData);
    const [countryValue, setCountryValue] = useState(country);
    const [emailLang, setEmailLang] = useState(language);
    const [marketings, setmarketings] = useState(false);
    const [googleLogins, setgoogleLogins] = useState(false);

    useEffect(() => {
        userinfos();
        setCountryValue(country);
    }, [country]);
    const userinfos = async () => {
        const ckresult = await API.xsollaApis("user/userinfos", { idx: mbData?.idx });
        setgoogleLogins(ckresult?.result);
    }
    useEffect(() => {
        setEmailLang(language);
    }, [language]);

    const handleDone = () => {
        onDone(countryValue, emailLang, googleLogins === true ? marketings : 'none' );
    };

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '32px',
                gap: '32px',
                width: '400px',
                height: 'auto',
                background: '#FFFFFF',
                borderRadius: '20px',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    padding: '0px',
                    gap: '20px',
                    width: '336px',
                    height: 'auto',
                    flex: 'none',
                    order: 0,
                    alignSelf: 'stretch',
                    flexGrow: 0,
                }}
            >
                {/*<div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        padding: '0px',
                        gap: '8px',
                        width: '336px',
                        height: '79px',
                        flex: 'none',
                        order: 0,
                        alignSelf: 'stretch',
                        flexGrow: 0,
                    }}
                >
                     <div
                        style={{
                            width: '336px',
                            height: '19px',
                            fontFamily: 'Pretendard',
                            fontStyle: 'normal',
                            fontWeight: 400,
                            fontSize: '16px',
                            lineHeight: '19px',
                            display: 'flex',
                            alignItems: 'center',
                            color: '#121316',
                            flex: 'none',
                            order: 0,
                            alignSelf: 'stretch',
                            flexGrow: 0,
                        }}
                    >
                        Country
                    </div>

                    <div
                        style={{
                            boxSizing: 'border-box',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            padding: '0px 8px 0px 20px',
                            width: '336px',
                            height: '52px',
                            background: '#FFFFFF',
                            border: '1px solid #DDDDDD',
                            borderRadius: '8px',
                            flex: 'none',
                            order: 1,
                            alignSelf: 'stretch',
                            flexGrow: 0,
                        }}
                    >
                        <select
                            style={{
                                width: '288px',
                                height: '19px',
                                fontFamily: 'Pretendard',
                                fontStyle: 'normal',
                                fontWeight: 400,
                                fontSize: '16px',
                                lineHeight: '19px',
                                display: 'flex',
                                alignItems: 'center',
                                color: '#121316',
                                flexGrow: 1,
                                border: 'none',
                                outline: 'none',
                                background: 'transparent',
                            }}
                            value={countryValue}
                            onChange={(e) => setCountryValue(e.target.value)}
                        >
                            <option value="US">United States of America</option>
                            <option value="KR">대한민국</option>
                        </select>

                        <div
                            style={{
                                width: '20px',
                                height: '20px',
                                flex: 'none',
                                order: 1,
                                flexGrow: 0,
                                position: 'relative',
                            }}
                        >
                            <div
                                style={{
                                    position: 'absolute',
                                    width: '11.5px',
                                    height: '6.5px',
                                    left: '4.25px',
                                    top: '7.25px',
                                    background: '#121316',
                                }}
                            />
                        </div>
                    </div>
                </div> */}

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        padding: '0px',
                        gap: '8px',
                        width: '336px',
                        height: '79px',
                        flex: 'none',
                        order: 1,
                        alignSelf: 'stretch',
                        flexGrow: 0,
                    }}
                >
                    <div
                        style={{
                            width: '336px',
                            height: '19px',
                            fontFamily: 'Pretendard',
                            fontStyle: 'normal',
                            fontWeight: 400,
                            fontSize: '16px',
                            lineHeight: '19px',
                            display: 'flex',
                            alignItems: 'center',
                            color: '#121316',
                            flex: 'none',
                            order: 0,
                            alignSelf: 'stretch',
                            flexGrow: 0,
                        }}
                    >
                        Email Notification Language
                    </div>

                    <div
                        style={{
                            boxSizing: 'border-box',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            padding: '0px 8px 0px 20px',
                            width: '336px',
                            height: '52px',
                            background: '#FFFFFF',
                            border: '1px solid #DDDDDD',
                            borderRadius: '8px',
                            flex: 'none',
                            order: 1,
                            alignSelf: 'stretch',
                            flexGrow: 0,
                        }}
                    >
                        <select
                            style={{
                                width: '288px',
                                height: '19px',
                                fontFamily: 'Pretendard',
                                fontStyle: 'normal',
                                fontWeight: 400,
                                fontSize: '16px',
                                lineHeight: '19px',
                                display: 'flex',
                                alignItems: 'center',
                                color: '#121316',
                                flexGrow: 1,
                                border: 'none',
                                outline: 'none',
                                background: 'transparent',
                            }}
                            value={emailLang}
                            onChange={(e) => setEmailLang(e.target.value)}
                        >
                            <option value="en">English</option>
                            <option value="ko">한국어</option>
                        </select>
                        <div
                            style={{
                                width: '20px',
                                height: '20px',
                                position: 'relative',
                            }}
                        >
                            <div
                                style={{
                                    position: 'absolute',
                                    width: '11.5px',
                                    height: '6.5px',
                                    left: '4.25px',
                                    top: '7.25px',
                                    background: '#121316',
                                }}
                            />
                        </div>
                    </div>
                                        
                </div>
                {googleLogins === true &&
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        padding: '0px',
                        gap: '8px',
                        width: '336px',
                        height: 'auto',
                        flex: 'none',
                        order: 1,
                        alignSelf: 'stretch',
                        flexGrow: 0,
                    }}
                >
                    <div style={{ fontWeight: 700, fontSize: 15, textDecoration: 'underline' }}>
                    Marketing Information Reception
                    </div>
                    <div className="custom_chk_box inquiry profile" style={{ width: '100%'}}>
                        <input
                            type="checkbox"
                            className="custom_chk_input"
                            id="marketting_sns"
                            checked={marketings}
                            onChange={() => {
                                setmarketings(!marketings);
                            }}
                        />
                        <label htmlFor="marketting_sns" className="custom_chk_label" style={{ fontSize: 11}}>
                            I agree to receive marketing communications, including updates, offers, and newsletters, from UModeler.
                        </label>
                    </div>
                </div>   }             
            </div>

            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '0px',
                    gap: '8px',
                    width: '336px',
                    height: '64px',
                    flex: 'none',
                    order: 1,
                    alignSelf: 'stretch',
                    flexGrow: 0,
                }}
            >
                <button
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '0px',
                        gap: '20px',
                        width: '336px',
                        height: '64px',
                        background: '#0E6AF4',
                        borderRadius: '8px',
                        border: 'none',
                        cursor: 'pointer',
                    }}
                    onClick={handleDone}
                >
                    <span
                        style={{
                            width: '50px',
                            height: '24px',
                            fontFamily: 'Pretendard',
                            fontStyle: 'normal',
                            fontWeight: 700,
                            fontSize: '20px',
                            lineHeight: '24px',
                            display: 'flex',
                            alignItems: 'center',
                            textAlign: 'center',
                            color: '#FFFFFF',
                        }}
                    >
                        Done
                    </span>
                </button>
            </div>
        </div>
    );
}